<template>
  <div class="details-view tab-warning" style="height: 600px !important;">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{'max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      style="min-height:90%"
    >
      <template slot="left">
        <div class="main-content">
          <div style="margin: 6px 0px 0px 10px;">
            <cargo-advance-select
              :cache="false"
              tag-name="name"
              tag-value="code"
              :clearable="false"
              :filter-tag-names="['name']"
              filter-type="global"
              :default-value="filter.type"
              :static-options="selectedList"
              @parentCallBack="changeSelectType"
            />
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-options="leftGridOptions"
              :row-data="leftRowData"
              :show-side-bar="false"
              min-height="100%"
              class="section"
              grid-style="min-width: 240px;width:100%;height:90%;min-height:496px"
              @gridReady="p=>{gridApi=p.api}"
            />
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin: 6px">
            <el-button type="primary" @click="fetchData()">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
            <el-button v-show="showDealBtn" type="danger" @click="onHandled()">{{ $t('Sop.ignoreMessage') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              config-module="11005"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              grid-style="width:100%;height:90%;min-height:496px"
            />
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <div style="min-height: 30px; height: 100%;position: relative">
      <div style="position: absolute; right: 5px;">
        <cargo-pagination
          config-module="11005"
          :total="filter.total || 0"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="queryTodoItemList"
        />
      </div>
    </div>
    <bill-payment-dialog
      v-if="billPaymentDialog.visible"
      :visible.sync="billPaymentDialog.visible"
      :title="billPaymentDialog.title"
      :bill-payment-uuid="billPaymentDialog.billPaymentUuid"
      :is-direct-payment="isDirectPayment"
      :location="location"
      :append-to-body="true"
      :modal-append-to-body="true"
      @cancel="closeBillPaymentDialog"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { batchCompletedItemFunc, queryTodoCategoryFunc, queryTodoItemFunc } from '@/api/commonComponent'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/billPaymentDialog'
import { LOG_BILL_PAYMENT } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabWarning',
  components: { CargoAdvanceSelect, CargoLeftRightResize, billPaymentDialog },
  props: {
    module: { type: String, default: () => 'paymentApply' }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      showDealBtn: false,
      location: LOG_BILL_PAYMENT.code,
      isDirectPayment: false,
      billPaymentDialog: {
        visible: false,
        title: '',
        billPaymentUuid: ''
      },
      fullscreenLoading: null,
      filter: {
        type: ' ',
        module: 'paymentApply',
        categoryType: '',
        branchId: 0,
        total: 0,
        pageNum: 1,
        pageSize: 15
      },
      gridApi: null,
      leftRowData: [],
      leftGridOptions: {
        rowSelection: 'single',
        groupDefaultExpanded: 2,
        defaultColDef: {
          lockPosition: false // 禁止拖动列的位置
        },
        columnDefs: [{
          headerName: this.$t('CargoMsg.Cargo_AlertTodoCategoryList'),
          colId: 'categoryName',
          field: 'categoryName',
          width: 180,
          tooltip: (params) => {
            return params.data ? params.data['categoryName'] : ''
          },
          cellRenderer: (params) => {
            const iconClass = params.data.type === 'TODO' ? `<i class="el-icon-message-solid" style="font-size: 12px"></i>&nbsp;&nbsp;` : `<i class="el-icon-warning"></i>`
            const colorClass = params.data.count > 0 ? 'radio-number has-data' : 'radio-number no-data'
            return `${iconClass}<span>${params.data.categoryName}</span><span class="${colorClass}"><span class="number"> ${params.data.count || 0}</span></span>`
          }
        }],
        suppressContextMenu: false,
        context: {
          componentParent: this
        },
        onCellClicked: this.leftGridOnCellClicked
      },
      gridOptions: {
        rowSelection: 'multiple',
        onRowSelected: (params) => {
          this.selectedRows = params.api.getSelectedRows()
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        }
      },
      rowData: [],
      selectedRows: null,
      loading: null,
      selectedList: [{ code: ' ', name: '全部' }, { code: 'TODO', name: '待办' }, { code: 'WARNING', name: '预警' }] }
  },
  computed: {
    hasSelected() {
      return this.selectedRows && this.selectedRows.length
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    columnDefs() {
      return [
        {
          headerName: '', width: 80, checkboxSelection: true, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, lockVisible: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TodoAlert'),
          field: 'type',
          colId: 'type',
          valueFormatter: params => {
            return params.value && params.value === 'TODO' ? this.$t('CargoMsg.Cargo_Todo') : this.$t('CargoMsg.Cargo_Alert')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemDescription'),
          field: 'content',
          colId: 'content'
        },
        {
          headerName: this.$t('FinanceManage.sendingTime'),
          field: 'dateCreated',
          colId: 'dateCreated',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LookDetail'),
          field: 'businessNo',
          cellRendererFramework: 'agGridColumnEdit',
          enableRowGroup: true,
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  this.toJumpSalesQuery(params.data)
                }
              }
            }
          },
          width: 200
        }
      ]
    }
  },
  watch: {
    async officeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.fetchData()
      }
    },
    // When the payment dialog closes (cancel button, close icon, etc.), refresh the todo list.
    'billPaymentDialog.visible': async function(val, oldVal) {
      if (oldVal && !val) {
        await this.fetchData()
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    closeBillPaymentDialog() {
      this.billPaymentDialog.visible = false
    },
    async fetchData(refreshType = false) {
      if (refreshType) {
        this.filter.type = ' '
      }
      this.filter.module = this.module
      this.filter.categoryType = ''
      this.queryCategoryList()
      this.onQuery()
    },
    clearGrid() {
      this.filter.total = 0
      this.filter.pageNum = 1
      this.filter.pageSize = 15
      this.leftGridOptions.api.refreshCells({ force: true })
      this.leftGridOptions.api.clearFocusedCell()
    },
    onQuery() {
      this.queryTodoItemList()
      this.$emit('resetCount')
    },
    // 左侧事项分类子类列表查询
    queryCategoryList() {
      queryTodoCategoryFunc({ ...this.filter }).then((res) => {
        this.leftRowData = res.data || []
        if (this.leftGridOptions.api) {
          this.leftGridOptions.api.refreshCells({ force: true })
          this.leftGridOptions.api.clearFocusedCell()
        }
      })
    },
    // 右侧事项明细列表查询
    queryTodoItemList() {
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.status = 0
      this.fullscreenLoading = getLoading('tab-warning')
      queryTodoItemFunc({ ...this.filter }).then((res) => {
        const pageInfo = res.data
        this.rowData = pageInfo.list
        this.filter.total = pageInfo.total ? Number(pageInfo.total) : 0
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    onHandled() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_IgnoreSelectedData'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const itemKeys = []
        for (const item of selectedRows) {
          itemKeys.push(item.uuid)
        }
        if (!itemKeys) {
          this.$message.warning(this.$t('Pricing.NoRecordSelect'))
          return
        }
        this.fullscreenLoading = getLoading('tab-warning')
        batchCompletedItemFunc(itemKeys).then(res => {
          this.$message.success(this.$t('Message.OperationSuccessfully'))
          this.$nextTick(() => {
            this.onQuery()
            this.gridOptions.api.refreshCells({ force: true })
            this.gridOptions.api.clearFocusedCell()
          })
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    leftGridOnCellClicked(event) {
      const data = event.data
      // 如果是已处理，已忽略，去除对应按钮
      this.showDealBtn = data.type === 'WARNING'
      this.filter.categoryType = data.categoryType
      this.filter.module = this.module
      this.queryTodoItemList()
    },
    changeSelectType(p) {
      this.filter.type = p.value
      this.fetchData()
    },
    // 跳转至销售查询
    toJumpSalesQuery(data) {
      // 销售查询-费用页签跳转
      if (data.categoryType === 'feeQuoteDiff') {
        if (!data.businessNo) {
          return
        }
        if (!this.$checkPermission(['module_SalesQueryModule'])) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
          return
        }
        this.$router.push({ name: 'SalesQuery', params: { businessNo: data.businessNo }})
      } else if (data.categoryType === 'billPaymentLackInvoice' || data.categoryType === 'billPaymentHandlerEvent') {
        // 付款申请缺少发票：跳转到付款申请单详情（优先直接打开明细弹窗）
        const billPaymentUuid = data.businessId || data.billPaymentUuid || data.businessUuid || data.targetUuid || data.refUuid || ''
        if (!billPaymentUuid && !data.businessNo) {
          return
        }
        if (!billPaymentUuid) {
          return
        }
        this.billPaymentDialog.billPaymentUuid = billPaymentUuid
        this.billPaymentDialog.title = this.$t('CargoMsg.Cargo_ViewPaymentRequest')
        this.billPaymentDialog.visible = true
      } else if (data.categoryType === 'WAIT_TO_INVOICE') {
        if (!data.businessNo) {
          return
        }
        // SeaBooking 的父路由 /SeaExport/:code/:name/:subCode/:subName/:etdStart/:etdEnd/:jobState 需要 params，
        // 从 dashboard 跳转时需补齐这些参数，否则会因为缺少必填 params 导致路由不跳转。
        this.$router.push({
          name: 'SeaBooking',
          query: { openNew: true, key: data.businessNo },
          params: { action: 'look', activeTabName: 'tabCharges' } // rowData 可不传，不传会走接口查询
        })
      } else if (data.categoryType === 'negativeProfitOrder') {
        if (!data.businessNo) {
          return
        }
        this.$router.push({ name: 'NegativeProfitOrder', query: { jobNo: data.businessNo }})
      } else if (data.categoryType === 'payableUnverifiedOrder') {
        if (!data.businessNo) {
          return
        }
        this.$router.push({
          name: 'NegativeProfitOrder',
          query: { tab: 'payableUnverifiedOrder', jobNo: data.businessNo }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .tab-warning{
    .el-icon-warning{
      font-size: 14px;
      margin-right: 5px;
    }
    .ag-cell-value{
      padding: 0 40px;
    }
    .radio-number{
      border-radius: 24%;
      height: 18px;
      width: 30px;
      display: inline-block;
      position: absolute;
      right:0;
      top:0;
      margin: 4px;
      .number{
        display: block;
        color: #FFFFFF;
        height: 18px;
        line-height: 18px;
        text-align: center
      }
    }
    .has-data{
      background: #f56c6c;
    }
    .no-data{
      background: #42B983;
    }
    .el-icon-remove{
      font-size: 16px;
      color: $--color-primary;
    }
    .select-data {
      border: 2px solid #006EBE;
      padding: 5px;
      margin-right: 5px;
      color: #006EBE;
      cursor: pointer;
      border-radius: 5px;
      user-select: none; /* 阻止文本被选中和复制 */
    }
    .no-select-data {
      border: 2px solid black;
      padding: 5px;
      margin-right: 5px;
      color: black;
      cursor: pointer;
      border-radius: 5px;
      user-select: none; /* 阻止文本被选中和复制 */
    }
  }
</style>
